import { render, staticRenderFns } from "./travel-recommend.vue?vue&type=template&id=074edeee"
import script from "./travel-recommend.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-recommend.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-recommend.vue?vue&type=style&index=0&id=074edeee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports